export default __webpack_public_path__ + "static/media/Rc.a2b7d03f.png";